import React from "react";
import { Box, Flex } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { OnePassBackgroundWatermark } from "../../pure/OnePassBackgroundWatermark";
const UpsellBoxFlex = styled(Flex) `
  & {
    padding: ${themeGet("space.2")};
  }

  & > div {
    padding: ${themeGet("space.2")};
  }

  @media screen and (min-width: ${themeGet("breakpoints.md")}) {
    & {
      padding: ${themeGet("space.3")};
    }

    & > div {
      padding: ${themeGet("space.3")};
    }
  }
`;
export const UpsellBoxZone = ({ children }) => {
    return (<Box backgroundColor="onePass.textPrimary" borderRadius="corner" overflow="hidden" fontFamily="onePass" color="white" position="relative" mb={6}>
      <OnePassBackgroundWatermark />
      <UpsellBoxFlex zIndex={1} position="relative" flexWrap="wrap">
        {children}
      </UpsellBoxFlex>
    </Box>);
};
export const UpsellCopyZone = ({ children }) => {
    return (<Box flexGrow={2} flexShrink={1} flexBasis={{
            xs: "100%",
            md: "auto",
            lg: "35%",
        }}>
      {children}
    </Box>);
};
export const BenefitsCopyZone = styled(Box) `
  & {
    margin-bottom: ${themeGet("space.5")};
  }

  & > * {
    margin-bottom: ${themeGet("space.3")};
  }
`;
export const BenefitIconZone = styled(Box) `
  & {
    svg {
      width: ${themeGet("space.5")};
      height: ${themeGet("space.6")};
      color: inherit;
    }

    margin-right: ${themeGet("space.3")};
  }
`;
export const BenefitRowZone = styled(Flex) `
  & {
    align-items: center;
  }
`;
export const PlanOptionsZone = ({ children, }) => {
    return (<Flex flexGrow={4} flexShrink={0} flexBasis={{
            xs: "100%",
            md: "50%",
            lg: "auto",
        }} alignItems="stretch" flexDirection="column">
      {children}
    </Flex>);
};
export const SideImageZone = ({ children }) => {
    return (<Flex flexGrow={1} flexShrink={2} flexBasis={{
            xs: "100%",
            md: "auto",
        }} alignItems="flex-end" justifyContent="center">
      {children}
    </Flex>);
};
